// 门户系统公用路由文件
import BasicLayout from '../../layouts/BasicLayout'

export default [{
        path: '/egw/sm/pagedesign',
        name: 'pagedesign',
        component: () =>
            import ('../../views/egw/sm/pageDesign'),
        meta: { title: '页面定制' }
    },

    {
        path: '/egw/sm/templateView',
        name: 'templateView',
        component: () =>
            import ('../../views/egw/sm/templateView'),
        meta: { title: '模板预览' }
    },
    {
        path: '/egw',
        component: BasicLayout,
        children: [{
                path: '/egw/cms/mainlist',
                name: 'CmsMainList',
                component: () =>
                    import ('../../views/egw/cms/CmsMainList'),
                meta: { title: '信息发布' }
            },
            {
                path: '/egw/cms/mainedit',
                name: 'CmsMainEdit',
                component: () =>
                    import ('../../views/egw/cms/CmsMainEdit'),
                meta: { title: '信息新增修改' }
            },

            {
                path: '/egw/cms/mainaudit/:todoid/:biz_uuid',
                name: 'CmsMainAudit',
                component: () =>
                    import ('../../views/egw/cms/CmsMainAudit'),
                meta: { title: '信息审批' }
            },
            {
                path: '/egw/cms/contribute',
                name: 'CmsContributeList',
                component: () =>
                    import ('../../views/egw/cms/CmsContributeList'),
                meta: { title: '信息报送' }
            },
            {
                path: '/egw/cms/CmsMessengerList',
                component: () =>
                    import ('../../views/egw/cms/CmsMessengerList'),
                meta: { title: '信息员审核' }
            },
            {
                path: '/egw/cms/merge',
                name: 'CmsMainMergeAdd',
                component: () =>
                    import ('../../views/egw/cms/CmsMainMergeAdd'),
                meta: { title: '信息合并' }
            }, //信息合并
            {
                path: '/egw/cms/contributeedit',
                name: 'CmsContributeEdit',
                component: () =>
                    import ('../../views/egw/cms/CmsContributeEdit'),
                meta: { title: '信息报送编辑' }
            },
            {
                path: '/egw/cms/contributeedit2',
                name: 'CmsContributeEdit2',
                component: () =>
                    import ('../../views/egw/cms/CmsContributeEdit2'),
                meta: { title: '采编审核-编辑' }
            },
            {
                path: '/egw/cms/contributeaudit/:todoid/:biz_uuid',
                name: 'CmsContributeAudit',
                component: () =>
                    import ('../../views/egw/cms/CmsContributeAudit'),
                meta: { title: '信息报送审核' }
            },
            {
                path: '/egw/egwwfmonitor',
                name: 'EgwWfMonitor',
                component: () =>
                    import ('../../views/egw/common/EgwWfMonitor'),
                meta: { title: '流程监控' }
            },
            //采编投稿最后一步
            {
                path: '/egw/cms/contributeaudit2/:todoid/:biz_uuid',
                name: 'CmsContributeAudit2',
                component: () =>
                    import ('../../views/egw/cms/CmsContributeAudit2'),
                meta: { title: '信息投稿审核' }
            },
            {
                path: '/egw/cms/mylist',
                name: 'CmsMyList',
                component: () =>
                    import ('../../views/egw/cms/CmsMyList'),
                meta: { title: '我的稿件' }
            },
            {
                path: '/egw/cms/reportlist',
                name: 'CmsReportList',
                component: () =>
                    import ('../../views/egw/cms/CmsReportList'),
                meta: { title: '上报稿件' }
            },
            {
                path: '/egw/cms/contaudit',
                name: 'CmsContAuditList',
                component: () =>
                    import ('../../views/egw/cms/CmsContAuditList'),
                meta: { title: '采编审核' }
            },
            {
                path: '/egw/cms/CmsImproveList',
                component: () =>
                    import ('../../views/egw/cms/CmsImproveList'),
                meta: { title: '改善课题人员维护' }
            },
            {
                path: '/egw/cms/CmsImproveEdit',
                component: () =>
                    import ('../../views/egw/cms/CmsImproveEdit'),
                meta: { title: '改善课题人员修改' }
            },
            {
                path: '/egw/cms/multquery',
                name: 'CmsMulQueryList',
                component: () =>
                    import ('../../views/egw/cms/CmsMulQueryList'),
                meta: { title: '综合查询' }
            },
            {
                path: '/egw/cms/reportadd',
                name: 'CmsReportEdit',
                component: () =>
                    import ('../../views/egw/cms/CmsReportEdit'),
                meta: { title: '向省局报送' }
            },
            {
                path: '/egw/cms/exlist',
                name: 'ExCmsList',
                component: () =>
                    import ('../../views/egw/cms/ExCmsList'),
                meta: { title: '外投稿件维护' }
            },
            {
                path: '/egw/cms/exedit',
                name: 'ExCmsEdit',
                component: () =>
                    import ('../../views/egw/cms/ExCmsEdit'),
                meta: { title: '外投稿件新增或修改' }
            },
            {
                path: '/egw/column',
                component: () =>
                    import ('../../views/egw/col/ColumnList'),
                meta: { title: '栏目维护' }
            },
            {
                path: '/egw/columnedit',
                component: () =>
                    import ('../../views/egw/col/ColumnEdit'),
                meta: { title: '栏目维护' }
            },
            {
                path: '/egw/column/recycle',
                component: () =>
                    import ('../../views/egw/col/ColumnRecycleList'),
                meta: { title: '栏目回收站' }
            }, {
                path: '/egw/etc/itemlist',
                name: 'NavItemList',
                component: () =>
                    import ('../../views/egw/etc/NavItemList'),
                meta: { title: '导航管理' }
            },
            {
                path: '/egw/etc/itemtypelist',
                name: 'NavItemTypeList',
                component: () =>
                    import ('../../views/egw/etc/NavItemTypeList'),
                meta: { title: '导航分类管理' }
            },
            {
                path: '/egw/etc/flashlist',
                name: 'FlashList',
                component: () =>
                    import ('../../views/egw/etc/FlashList'),
                meta: { title: 'flash管理' }
            },
            {
                path: '/egw/etc/popuplist',
                name: 'PopupList',
                component: () =>
                    import ('../../views/egw/etc/PopupList'),
                meta: { title: '弹窗管理' }
            },
            {
                path: '/egw/etc/popupimglist',
                name: 'PopupImgList',
                component: () =>
                    import ('../../views/egw/etc/PopupImgList'),
                meta: { title: '漂浮图片管理' }
            },
            {
                path: '/egw/etc/counterlist',
                component: () =>
                    import ('../../views/egw/etc/CounterList'),
                meta: { title: '计数器管理' }
            },
            {
                path: '/egw/etc/statcounterlist',
                component: () =>
                    import ('../../views/egw/etc/StatCounterList'),
                meta: { title: '计数器统计' }
            },
            {
                path: '/egw/etc/directstorecityList',
                component: () =>
                    import ('../../views/egw/etc/DirectStoreCityList'),
                meta: { title: '直营店城市管理' }
            },
            {
                path: '/egw/etc/directstoreList',
                component: () =>
                    import ('../../views/egw/etc/DirectStoreList'),
                meta: { title: '直营店管理' }
            },
            {
                path: '/egw/mz/subjectlist',
                name: 'SubjectList',
                component: () =>
                    import ('../../views/egw/mz/MzSubjectList'),
                meta: { title: '期刊栏目维护' }
            },
            {
                path: '/egw/etc/commentlist',
                name: 'CommentList',
                component: () =>
                    import ('../../views/egw/etc/CommentList'),
                meta: { title: '评论管理' }
            },
            {
                path: '/egw/etc/commentaudit',
                component: () =>
                    import ('../../views/egw/etc/CommentAudit'),
                meta: { title: '评论审批' }
            },
            {
                path: '/egw/mz/mzlist',
                name: 'MzList',
                component: () =>
                    import ('../../views/egw/mz/MzList'),
                meta: { title: '期刊维护' }
            },
            {
                path: '/egw/sm/templatelist',
                name: 'templateList',
                component: () =>
                    import ('../../views/egw/sm/templateList'),
                meta: { title: '模板管理' }
            },

            {
                path: '/egw/mz/typelist',
                name: 'MzTypeList',
                component: () =>
                    import ('../../views/egw/mz/MzTypeList'),
                meta: { title: '期刊分类管理' }
            },
            {
                path: '/egw/mz/mzedit',
                name: 'MzEdit',
                component: () =>
                    import ('../../views/egw/mz/MzEdit'),
                meta: { title: '期刊新增编辑' }
            },
            {
                path: '/egw/mz/mainsubmitlist',
                name: 'MzMainSubmitList',
                component: () =>
                    import ('../../views/egw/mz/MzMainSubmitList'),
                meta: { title: '期刊投稿' }
            },
            {
                path: '/egw/mz/mainedit',
                name: 'MzMainEdit',
                component: () =>
                    import ('../../views/egw/mz/MzMainEdit'),
                meta: { title: '期刊投稿新增' }
            },
            {
                path: '/egw/mz/mainaudit/:todoid/:biz_uuid',
                name: 'MzMainAudit',
                component: () =>
                    import ('../../views/egw/mz/MzMainAudit'),
                meta: { title: '期刊投稿审批' }
            },
            {
                path: '/egw/mz/mzaudit/:todoid/:biz_uuid',
                name: 'MzAudit',
                component: () =>
                    import ('../../views/egw/mz/MzAudit'),
                meta: { title: '期刊发布审批' }
            },
            {
                path: '/egw/mz/mzedit/:todoid/:biz_uuid',
                name: 'MzEdit',
                component: () =>
                    import ('../../views/egw/mz/MzEdit'),
                meta: { title: '发布申请' }
            },
            {
                path: '/egw/mz/mainmanagelist',
                name: 'MzMainManageList',
                component: () =>
                    import ('../../views/egw/mz/MzMainManageList'),
                meta: { title: '期刊稿件管理' }
            },
            {
                path: '/egw/cms/videolist',
                name: 'CmsVideoList',
                component: () =>
                    import ('../../views/egw/cms/CmsVideoList'),
                meta: { title: '视频新闻' }
            },
            {
                path: '/egw/cms/videoedit',
                name: 'CmsVideoEdit',
                component: () =>
                    import ('../../views/egw/cms/CmsVideoEdit'),
                meta: { title: '视频新闻编辑' }
            },
            {
                path: '/egw/cms/mainview',
                name: 'CmsMainView',
                component: () =>
                    import ('../../views/egw/cms/CmsMainView'),
                meta: { title: '门户新闻查看' }
            },
            {
                path: '/egw/gf/mytodolist',
                component: () =>
                    import ('../../views/egw/gf/WfTodoList'),
                meta: { title: '我的待办' }
            },
            {
                path: '/egw/gf/mytodohislist',
                name: 'WfTodoHisList',
                component: () =>
                    import ('../../views/egw/gf/WfTodoHisList'),
                meta: { title: '我的经办' }
            },
            {
                path: '/egw/sm/sitelist',
                name: 'SmSiteList',
                component: () =>
                    import ('../../views/egw/sm/SmSiteList'),
                meta: { title: '站点管理' }
            },
            {
                path: '/egw/sm/siteedit',
                name: 'SmSiteEdit',
                component: () =>
                    import ('../../views/egw/sm/SmSiteEdit'),
                meta: { title: '站点修改' }
            },
            {
                path: '/egw/sm/pagelist',
                name: 'SmPageList',
                component: () =>
                    import ('../../views/egw/sm/SmPageList'),
                meta: { title: '页面管理' }
            },
            {
                path: '/egw/sm/componentlist',
                name: 'SmComponentList',
                component: () =>
                    import ('../../views/egw/sm/SmComponentList'),
                meta: { title: '组件管理' }
            },
            //--------视频文件管理
            {
                path: '/egw/vod/vodfolder',
                name: 'VideoFolder',
                component: () =>
                    import ('../../views/egw/vod/VideoFolder'),
                meta: { title: '视频分类' }
            },
            {
                path: '/egw/vod/vodfilelist',
                name: 'VideoFileList',
                component: () =>
                    import ('../../views/egw/vod/VideoFileList'),
                meta: { title: '视频维护' }
            },
            {
                path: '/egw/vod/videofilerecyclelist',
                name: 'VideoFileRecycleList',
                component: () =>
                    import ('../../views/egw/vod/VideoFileRecycleList'),
                meta: { title: '视频回收站' }
            },
            {
                path: '/egw/cms/maintype',
                name: 'CmsMainTypeList',
                component: () =>
                    import ('../../views/egw/cms/CmsMainTypeList'),
                meta: { title: '稿件类型' }
            },
            //----问卷调查
            {
                path: '/egw/vote/typelist',
                name: 'VoteTypeList',
                component: () =>
                    import ('../../views/egw/vote/VoteTypeList'),
                meta: { title: '问卷维护' }
            },
            {
                path: '/egw/vote/typeedit',
                name: 'VoteTypeEdit',
                component: () =>
                    import ('../../views/egw/vote/VoteTypeEdit'),
                meta: { title: '问卷分类新增修改' }
            },
            {
                path: '/egw/vote/answerinputedit',
                name: 'AnswerInputEdit',
                component: () =>
                    import ('../../views/egw/vote/AnswerInputEdit'),
                meta: { title: '调查项新增修改' }
            },
            {
                path: '/egw/vote/voteresultlist',
                name: 'VoteResultList',
                component: () =>
                    import ('../../views/egw/vote/VoteResultList'),
                meta: { title: '问卷结果统计' }
            },
            //----信息统计
            {
                path: '/egw/statistics/excount',
                name: 'ExCount',
                component: () =>
                    import ('../../views/egw/statistics/ExCount'),
                meta: { title: '外投稿件统计' }
            },
            {
                path: '/egw/statistics/unitpublishcount',
                name: 'UnitPublishCount',
                component: () =>
                    import ('../../views/egw/statistics/UnitPublishCount'),
                meta: { title: '单位发布量统计' }
            },
            {
                path: '/egw/statistics/unitcolumnpublishcount',
                name: 'UnitColumnPublishCount',
                component: () =>
                    import ('../../views/egw/statistics/UnitColumnPublishCount'),
                meta: { title: '单位栏目发布量统计' }
            },
            {
                path: '/egw/statistics/deptcolumnpublishcount',
                name: 'DeptColumnPublishCount',
                component: () =>
                    import ('../../views/egw/statistics/DeptColumnPublishCount'),
                meta: { title: '部门栏目发布量统计' }
            },
            {
                path: '/egw/statistics/columnpublishfrequency',
                name: 'ColumnPublishFrequency',
                component: () =>
                    import ('../../views/egw/statistics/ColumnPublishFrequency'),
                meta: { title: '栏目发布频率统计' }
            },
            {
                path: '/egw/statistics/deptpersoncolumnpubcount',
                name: 'DeptPersonColumnPubCount',
                component: () =>
                    import ('../../views/egw/statistics/DeptPersonColumnPubCount'),
                meta: { title: '上报稿件情况统计' }
            },
            {
                path: '/egw/statistics/deptcolumnpubcount',
                name: 'DeptColumnPubCount',
                component: () =>
                    import ('../../views/egw/statistics/DeptColumnPubCount'),
                meta: { title: '稿件录用情况统计' }
            },
            {
                path: '/egw/statistics/deptpersoncolumnpubdtl',
                name: 'DeptPersonColumnPubDtl',
                component: () =>
                    import ('../../views/egw/statistics/DeptPersonColumnPubDtl'),
                meta: { title: '上报稿件明细表' }
            },
            {
                path: '/egw/statistics/mainmoneystatistics',
                name: 'MainMoneyStatistics',
                component: () =>
                    import ('../../views/egw/statistics/MainMoneyStatistics'),
                meta: { title: '稿费统计' }
            },
            {
                path: '/egw/kbm/knowledgelist',
                name: 'KnowledgeList',
                component: () =>
                    import ('../../views/egw/kbm/KbmKnowledgeList'),
                meta: { title: '知识库列表' }
            },
            {
                path: '/egw/kbm/knowledgeedit',
                name: 'KnowledgeEdit',
                component: () =>
                    import ('../../views/egw/kbm/KbmknowledgeEdit'),
                meta: { title: '知识库修改' }
            },
            {
                path: '/egw/kbm/typelist',
                name: 'KbmTypeList',
                component: () =>
                    import ('../../views/egw/kbm/KbmTypeList'),
                meta: { title: '知识分类' }
            },
            {
                path: '/egw/oua/applyList',
                name: 'OUApplyList',
                component: () =>
                    import ('../../views/egw/oua/ApplyList'),
                meta: { title: '依申请公开' }
            },
            {
                path: '/egw/oua/applyView',
                name: 'OUApplyView',
                component: () =>
                    import ('../../views/egw/oua/ApplyView'),
                meta: { title: '依申请公开详情' }
            },
            {
                path: '/egw/oua/ApplyAdd',
                name: 'ApplyAdd',
                component: () =>
                    import ('../../views/egw/oua/ApplyAdd'),
                meta: { title: '依申请公开新增' }
            },
            {
                path: '/egw/oua/applyEdit',
                name: 'OUApplyEdit',
                component: () =>
                    import ('../../views/egw/oua/ApplyEdit'),
                meta: { title: '依申请公开修改' }
            },
            {
                path: '/egw/oua/applyAudit/:todoid/:biz_uuid',
                name: 'OUApplyAudit',
                component: () =>
                    import ('../../views/egw/oua/ApplyAudit'),
                meta: { title: '依申请公开审批' }
            },
            {
                path: '/egw/oua/messageList',
                name: 'OuaMessageList',
                component: () =>
                    import ('../../views/egw/oua/MessageList'),
                meta: { title: '留言' }
            },
            {
                path: '/egw/oua/MessageAdd',
                name: 'MessageAdd',
                component: () =>
                    import ('../../views/egw/oua/MessageAdd'),
                meta: { title: '留言新增' }
            },
            {
                path: '/egw/oua/MessageView',
                name: 'OuaMessageView',
                component: () =>
                    import ('../../views/egw/oua/MessageView'),
                meta: { title: '留言详情' }
            },
            {
                path: '/egw/oua/messageAudit/:todoid/:biz_uuid',
                name: 'OuaMessageAudit',
                component: () =>
                    import ('../../views/egw/oua/MessageAudit'),
                meta: { title: '留言审批' }
            },
            {
                path: '/egw/oua/MessageEdit',
                name: 'OuaMessageEdit',
                component: () =>
                    import ('../../views/egw/oua/MessageEdit'),
                meta: { title: '留言修改' }
            },
            {
                path: '/egw/access/wordList',
                name: 'wordList',
                component: () =>
                    import ('../../views/egw/access/WordList'),
                meta: { title: '敏感词列表' }
            },
            {
                path: '/egw/access/wordView',
                name: 'wordView',
                component: () =>
                    import ('../../views/egw/access/WordView'),
                meta: { title: '敏感词详情' }
            },
            {
                path: '/egw/access/ruleList',
                name: 'ruleList',
                component: () =>
                    import ('../../views/egw/access/WarningRuleList'),
                meta: { title: '异常规则列表' }
            },
            {
                path: '/egw/access/ruleView',
                name: 'ruleView',
                component: () =>
                    import ('../../views/egw/access/WarningRuleView'),
                meta: { title: '异常规则详情' }
            },
            {
                path: '/egw/access/warningList',
                name: 'warningList',
                component: () =>
                    import ('../../views/egw/access/AccessWarningList'),
                meta: { title: '异常报警列表' }
            },
            {
                path: '/egw/access/warningView',
                name: 'warningView',
                component: () =>
                    import ('../../views/egw/access/AccessWarningView'),
                meta: { title: '异常报警详情' }
            },
            //办事公开
            {
                path: '/egw/work/WorkSayList',
                component: () =>
                    import ('../../views/egw/work/WorkSayList'),
                meta: { title: '我向领导说句话' }
            },
          {
            path: '/egw/work/WorkSayEdit',
            component: () => import ('../../views/egw/work/WorkSayEdit'),
            meta: { title: '新增信息' }
          },
          {
            path: '/egw/work/WorkSayAudit/:todoid/:biz_uuid',
            component: () => import ('../../views/egw/work/WorkSayAudit'),
            meta: { title: '信息审核' }
          },
          {
            path: '/egw/oua/OuaManualList',
            component: () => import ('../../views/egw/oua/OuaManualList'),
            meta: { title: '手工录入' }
          },
          {
            path: '/egw/oua/OuaManualEdit',
            component: () => import ('../../views/egw/oua/OuaManualEdit'),
            meta: { title: '手工录入修改' }
          },
          {
            path: '/egw/oua/OuaApplyList',
            component: () => import ('../../views/egw/oua/OuaApplyList'),
            meta: { title: '依申请处理' }
          },
          {
            path: '/egw/oua/OuaApplyEdit',
            component: () => import ('../../views/egw/oua/OuaApplyEdit'),
            meta: { title: '依申请公开修改' }
          },
          {
            path: '/egw/oua/OuaApplyView',
            component: () => import ('../../views/egw/oua/OuaApplyView'),
            meta: { title: '依申请公开详情' }
          },
          {
            path: '/egw/oua/OuaApplyAudit/:todoid/:biz_uuid',
            component: () => import ('../../views/egw/oua/OuaApplyAudit'),
            meta: { title: '依申请公开审核' }
          },
          {
            path: '/egw/oua/OuaRecordList',
            component: () => import ('../../views/egw/oua/OuaRecordList'),
            meta: { title: '依申请公开备案' }
          },
          {
            path: '/egw/oua/OuaRecordEdit',
            component: () => import ('../../views/egw/oua/OuaRecordEdit'),
            meta: { title: '依申请公开备案修改' }
          },
          {
            path: '/egw/oua/OuaSuperviseList',
            component: () => import ('../../views/egw/oua/OuaSuperviseList'),
            meta: { title: '督办单管理' }
          },
          {
            path: '/egw/oua/OuaSuperviseEdit',
            component: () => import ('../../views/egw/oua/OuaSuperviseEdit'),
            meta: { title: '督办单修改' }
          },
          {
            path: '/egw/oua/OuaSuperviseView',
            component: () => import ('../../views/egw/oua/OuaSuperviseView'),
            meta: { title: '督办单详情' }
          },
          {
            path: '/egw/oua/OuaSuperviseAudit/:todoid/:biz_uuid',
            component: () => import ('../../views/egw/oua/OuaSuperviseAudit'),
            meta: { title: '督办单审核' }
          },
          //小应用组件
          {
            path: '/egw/etc/DutyPlaceList',
            component: () => import ('../../views/egw/etc/DutyPlaceList'),
            meta: { title: '值班地点维护' }
          },
          {
            path: '/egw/etc/DutyPlaceEdit',
            component: () => import ('../../views/egw/etc/DutyPlaceEdit'),
            meta: { title: '值班地点修改' }
          },
          {
            path: '/egw/etc/DutyInfoList',
            component: () => import ('../../views/egw/etc/DutyInfoList'),
            meta: { title: '值班维护'}
          },
          {
            path: '/egw/etc/DutyInfoEdit',
            component: () => import ('../../views/egw/etc/DutyInfoEdit'),
            meta: { title: '值班信息修改'}
          },
        ]
    },
    {
        path: '/egw/oua/PrintApplyView',
        name: 'PrintApplyView',
        component: () =>
            import ('../../views/egw/oua/PrintApplyView'),
        meta: { title: '依申请公开打印' }
    },
]